import { getDisplayTextFromExchange, getExhangeColor } from "src/utils/methods";
const TextFromExchange = ({ exchange, exchangeType, renderExchangeText, }) => {
    const exchangeText = getDisplayTextFromExchange(exchange, exchangeType);
    const exchangeColor = getExhangeColor(exchangeText);
    return renderExchangeText(exchangeText, exchangeColor);
};
export default TextFromExchange;
